import { useTranslation } from "react-i18next";
import { Camera } from "lucide-react";
import { DocAlert } from "./DocAlert";
import { FaceEnrollButton } from "./FaceEnrollButton";
import { RemoteBadge } from "./RemoteBadge";

const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const CAM_BTN = "absolute bottom-0 end-0 flex h-8 w-8 items-center justify-center rounded-full border-2 border-background bg-primary text-white shadow-neu-sm transition hover:scale-105";

export const EmployeeHero = ({ profile, userId, canEdit, onDone }) => {
  const { t } = useTranslation();
  const p = profile || {};
  return (
    <div className="flex flex-col items-center text-center" data-testid="detail-hero">
      <div className="relative h-28 w-28 rounded-full bg-gradient-to-br from-primary/70 via-primary/25 to-transparent p-[3px] shadow-neu-sm">
        <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-background" data-testid="detail-avatar">
          {p.reference_face ? (
            <img src={p.reference_face} alt={p.name} className="h-full w-full rounded-full object-cover" data-testid="detail-avatar-image" />
          ) : (
            <span className="text-3xl font-black text-primary/70">{initials(p.name)}</span>
          )}
        </div>
        {canEdit ? (
          <FaceEnrollButton userId={userId} enrolled={p.face_enrolled} onDone={onDone} className={CAM_BTN} />
        ) : (
          <span className={CAM_BTN}><Camera className="h-4 w-4" /></span>
        )}
      </div>
      {p.job_title ? <p className="mt-4 text-sm text-muted-foreground" data-testid="detail-job-title">{p.job_title}</p> : null}
      <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
        <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">{p.role ? t(`roles.${p.role}`) : "—"}</span>
        <RemoteBadge workMode={p.work_mode} since={p.remote_since} />
      </div>
      <DocAlert personal={p.personal} testId="detail-doc-alert" />
    </div>
  );
};
